// Function to create a regex from the model filter string
export const createRegexFromFilter = (modelFilter: string) => {
    // Split the modelFilter into individual words
    const words = modelFilter.split(/\s+/).filter(word => word);

    // Escape special characters in each word and create a combined regex pattern
    const escapedWords = words.map(word => word.replace(/[^\w\s]/g, '\\$&'));
    const combinedPattern = escapedWords.map(word => `(?=.*${word})`).join('');

    // Return the case insensitive regex
    return new RegExp(combinedPattern, 'i');
};